// Modal Link Controller
// Handles links that should open modals via Turbo Streams
//
// Usage:
//   a[data-controller="modal-link"][data-modal-link-url-value="/path/to/edit"]
//
import { Controller } from "@hotwired/stimulus"
import { logger } from "../utilities/logger"

export default class extends Controller {
  static values = { url: String }

  connect() {
    // Ensure the modals container exists
    if (!document.getElementById('modals')) {
      const modalsContainer = document.createElement('div')
      modalsContainer.id = 'modals'
      document.body.appendChild(modalsContainer)
    }
  }

  click(event) {
    event.preventDefault()
    event.stopPropagation()

    logger.log('Modal link controller clicked! URL:', this.urlValue)

    fetch(this.urlValue, {
      method: 'GET',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin'
    })
    .then(response => {
      logger.log('Response status:', response.status, response.headers.get('Content-Type'))
      if (response.ok) {
        return response.text()
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }
    })
    .then(text => {
      logger.log('Response text length:', text.length, 'First 300 chars:', text.substring(0, 300))

      // Parse and execute turbo-stream elements
      const parser = new DOMParser()
      const doc = parser.parseFromString(text, 'text/html')
      const turboStreams = doc.querySelectorAll('turbo-stream')

      logger.log('Found turbo-stream elements:', turboStreams.length)

      turboStreams.forEach(stream => {
        // Get stream attributes
        const action = stream.getAttribute('action')
        const target = stream.getAttribute('target')
        const content = stream.querySelector('template')?.innerHTML || ''

        logger.log('Stream action:', action, 'target:', target, 'content length:', content.length)

        if (action && target) {
          const targetEl = document.getElementById(target) || document.querySelector(target)
          if (targetEl) {
            // Execute the stream action manually
            if (action === 'append') {
              targetEl.insertAdjacentHTML('beforeend', content)
            } else if (action === 'update') {
              targetEl.innerHTML = content
            } else if (action === 'replace') {
              targetEl.outerHTML = content
            } else if (action === 'remove') {
              targetEl.remove()
            }

            logger.log('Stream executed, target element now has', targetEl.children.length, 'children')
          } else {
            logger.error('Target element not found:', target)
          }
        }
      })
    })
    .catch(error => {
      logger.error('Error loading modal:', error)
    })
  }
}
